import { InjectionToken } from '@angular/core';
import { ProviderSummary } from 'mbs-ui-shared@models/Provider';
import { Observable } from 'rxjs';

export const PROVIDERS_TOKEN = new InjectionToken<Observable<ProviderSummary[]>>('PROVIDERS_TOKEN');
